import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Button } from 'wix-style-react'
import _ from 'lodash'


import { displayError } from 'components/NotificationController'
import ImageCrop from './ImageCrop'
import { uploadToStorage, uploadToStorageVideo } from '../../../controllers/storage'
import {
  processImage,
  processVideo,
  VIDEO_FILETYPES,
  IMAGE_FILETYPES
} from '../../../utils/uploadUtils'


class UploadAssetsButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      file: null
    }
  }

  onFileInputMounted = (ref) => { this.fileInput = ref }

  onClick = (e) => {
    console.log('UploadAssetsButton onClick')
    const input = findDOMNode(this.fileInput)
    input.value = null
    input.click()
  }

  onChange = (e) => {
    const { useCropModal } = this.props
    const files = e.target.files
    console.log('onChooseFile', files)
    if (files.length > 0) {
      const file = files[0]
      const typeArray = _.split(file.type, '/')
      if (typeArray[0] === 'image' && useCropModal) {
        console.log('file is image, set to state', file, 'current state', this.state.file)
        this.setState({file: file})
      } else {
        this.saveFile(file)
      }
    }
  }

  saveFile = (file) => {
    const { dispatch, appId, isVideo } = this.props

    if (isVideo) {
      processVideo(file).then(({videoFile, imageFile}) => {
        dispatch(uploadToStorageVideo(appId, videoFile, imageFile))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    } else {
      processImage(file).then((fileToUpload) => {
        dispatch(uploadToStorage(appId, fileToUpload))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    }
  }

  onCropComplete = (file) => {
    // console.log('onCropComplete', crop, pixelCrop)
    this.setState({file: null})
    if (!_.isNil(file)) this.saveFile(file)
  }

  renderCropModal = () => {
    const { file } = this.state
    if (!_.isNil(file)) {
      return (
        <ImageCrop
          file={file}
          onComplete={this.onCropComplete}
        />
      )
    }
  }

  render () {
    const { children } = this.props
    const accept = this.props.isVideo
      ? VIDEO_FILETYPES
      : IMAGE_FILETYPES

    const inputAttributes = {
      accept,
      type: 'file',
      style: { display: 'none' },
      multiple: true,
      ref: this.onFileInputMounted,
      onChange: this.onChange,
    }

    if (children) {
      return (
        <div onClick={this.onClick}>
          {children}
          <input {...inputAttributes} />
          {this.renderCropModal()}
        </div>
      )
    } else {
      return (
        <Button
          height='small'
          theme='whiteblue'
          onClick={this.onClick}
        >
          <span>Upload Assets</span>
          <input {...inputAttributes} />
          {this.renderCropModal()}
        </Button>
      )
    }
  }
}

UploadAssetsButton.defaultProps = {
  useCropModal: true
}

UploadAssetsButton.propTypes = {
  appId: PropTypes.string.isRequired,
  isVideo: PropTypes.bool.isRequired,
  useCropModal: PropTypes.bool
}

export default connect(null, null, null, { withRef: true })(UploadAssetsButton)



// WEBPACK FOOTER //
// ./src/components/editor/assetsManager/UploadAssetsButton.js